// Layout route for /admin/fallbacks — pure passthrough. The list page
// lives in admin.fallbacks.index.tsx; the detail page in
// admin.fallbacks.$id.tsx. See admin.bonds.tsx for the same pattern.

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/fallbacks')({
  component: FallbacksLayout,
});

function FallbacksLayout() {
  return <Outlet />;
}
